/* eslint-disable no-unused-vars */
import Globals from './components/globals-class'
const globals = new Globals()
